/**
 * Application routes
 */
export default function () {
  return [ {
    "route": "/",
    "templateUrl": "screens/home.html",
    "controller": "HomeController"
  }, {
    "route": "/organizations",
    "templateUrl": "screens/organizations.html",
    "controller": "OrganizationsController"
  }, {
    "route": "/organization/:id",
    "templateUrl": "screens/organization.html",
    "controller": "OrganizationController"
  }, {
    "route": "/questionnaires",
    "templateUrl": "screens/questionnaires.html",
    "controller": "QuestionnairesController"
  }, {
    "route": "/workspaces",
    "templateUrl": "screens/workspaces.html",
    "controller": "WorkspacesController"
  }, {
    "route": "/workspace/:id",
    "templateUrl": "screens/workspace.html",
    "controller": "WorkspaceController"
  }, {
    "route": "/people",
    "templateUrl": "screens/people.html",
    "controller": "PeopleController"
  }, {
    "route": "/questionnaires/:id",
    "templateUrl": "screens/questionnaire.html",
    "controller": "QuestionnaireController"
  }, {
    "route": "/questionnaires/:id/edit",
    "templateUrl": "screens/questionnaire_editor.html",
    "controller": "QuestionnaireEditorController"
  }, {
    "route": "/dashboard",
    "templateUrl": "screens/dashboard.html",
    "controller": "DashboardController"
  }, {
    "route": "/coachee/:id",
    "templateUrl": "screens/coachee.html",
    "controller": "CoacheeScreenController"
  }, {
    "route": "/profile",
    "templateUrl": "screens/profile.html",
    "controller": "ProfileController"
  }, {
    "route": "/request_password_reset",
    "templateUrl": "screens/password_reset_request.html",
    "controller": "PasswordResetRequestController"
  }, {
    "route": "/reset_password/:token",
    "templateUrl": "screens/password_reset.html",
    "controller": "PasswordResetController"
  }, {
    "route": "/create_account",
    "templateUrl": "screens/signup/request.html",
    "controller": "SignupRequestController"
  }, {
    "route": "/create_account/:token",
    "templateUrl": "screens/signup/finalize.html",
    "controller": "SignupFinalizeController"
  }, {
    "route": "/investigation/:id",
    "templateUrl": "screens/investigation.html",
    "controller": "InvestigationController"
  }, {
    "route": "/invitation/:token",
    "templateUrl": "screens/signup_from_invitation_email.html",
    "controller": "SignupFromInvitationEmailController"
  }]
}